import React, { Component } from 'react'
import { Segment, Form } from 'semantic-ui-react'

class ReportCasePaymentSection extends Component {
    render() {
        const { values, onChange } = this.props

        return (
            <Segment>
                <Form>
                    <Form.Input
                        label='Outstanding Amount'
                        value={values.totalOutstanding}
                        onChange={(e) => onChange('totalOutstanding', e.target.value)}
                    />

                    <Form.TextArea
                        label='Payment Remarks'
                        value={values.paymentRemark}
                        onChange={(e) => onChange('paymentRemark', e.target.value)}
                    />

                    <Form.Group widths='equal'>
                        <Form.Input
                            type='date'
                            label='Binding Released On'
                            value={toDateInput(values.bindingReleasedOn)}
                            onChange={(e) => onChange('bindingReleasedOn', e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group widths='equal'>
                        <Form.Input
                            type='date'
                            label='ACRA Filing Released On'
                            value={toDateInput(values.acraFilingReleasedOn)}
                            onChange={(e) => onChange('acraFilingReleasedOn', e.target.value)}
                        />
                        <Form.Input
                            type='date'
                            label='IRAS Filing Released On'
                            value={toDateInput(values.irasFilingReleasedOn)}
                            onChange={(e) => onChange('irasFilingReleasedOn', e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group widths='equal'>
                        <Form.Input
                            type='date'
                            label='Emailed Adj On'
                            value={toDateInput(values.emailedAdjOn)}
                            onChange={(e) => onChange('emailedAdjOn', e.target.value)}
                        />
                        <Form.Input
                            type='date'
                            label='Emailed Client Profile Page On'
                            value={toDateInput(values.emailedClientProfilePageOn)}
                            onChange={(e) => onChange('emailedClientProfilePageOn', e.target.value)}
                        />
                    </Form.Group>

                    <Segment
                        style={{ marginTop: 20 }}
                    >
                        <Form.Checkbox
                            toggle
                            label='Workflow Completed'
                            checked={!!values.workflowCompleted}
                            onChange={(e, { checked }) =>
                                onChange('workflowCompleted', checked)
                            }
                        />
                    </Segment>
                </Form>
            </Segment>
        )
    }
}

function toDateInput(d) {
    if (!d) return ''
    const date = new Date(d)
    if (Number.isNaN(date.getTime())) return ''
    return date.toISOString().slice(0, 10)
}

export default ReportCasePaymentSection